module.exports = __webpack_public_path__ + "img/arrow-right.d69616b9.svg";